import { Box, Button, Chip, Grid2, Link, Typography } from "@mui/material";
import React from "react";
import ContestUpcoming from "Assets/Images/ContestUpcoming.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as CompletedIcon } from "Assets/Icons/Curriculum/CompletedIcon.svg";
import { ReactComponent as TimeUpcoming } from "Assets/Icons/Classroom/TimerUpcoming.svg";
import { ReactComponent as CalendarUpcoming } from "Assets/Icons/Classroom/CalendarUpcoming.svg";
import { ReactComponent as PlacementIcon } from "Assets/Icons/Classroom/PlacementIcon.svg";
import { ReactComponent as TimerPlayIcon } from "Assets/Icons/Classroom/TimerPlayIcon.svg";
import { ReactComponent as TargetIcon } from "Assets/Icons/Classroom/TargetIcon.svg";
import { ReactComponent as ClockIcon } from "Assets/Icons/Home/ClockIcon.svg";
import ContestInstructions from "Components/Contest/ContestInstructions";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  "& .attemptBox": {
    background: theme.palette.white.main,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "start",
  },
  "& .impBox": {
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    background: theme.palette.background.default,
    padding: "16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "& .iconBox": {
      background: theme.palette.white.main,
      borderRadius: "8px",
      padding: "8px",
    },
  },
});

const ContestTab = () => {
  const impPoint = [
    {
      icon: PlacementIcon,
      content: (
        <Typography>
          This test is mandatory to become{" "}
          <Link href="#" underline="none" variant="body1">
            {" "}
            eligible for placements{" "}
          </Link>
        </Typography>
      ),
    },
    {
      icon: TargetIcon,
      content: (
        <Typography>
          Enhances
          <Link href="#" underline="none" variant="body1">
            {" "}
            pressure handling and quick thinking{" "}
          </Link>
          for interviews
        </Typography>
      ),
    },
    {
      icon: TimerPlayIcon,
      content: (
        <Typography>Helps withrevisionof concepts and problems</Typography>
      ),
    },
  ];

  const similarContests = [
    {
      label: "DSML Module Test: DAV - Probability and Stats",
      time: "18 Oct, 6:00 PM - 27 Oct, 11:00 PM",
      button: "View Contest",
      color: "#FEE0CC",
    },
    {
      label: "DSML Module Test: DAV - Probability and Stats",
      time: "18 Oct, 6:00 PM - 27 Oct, 11:00 PM",
      button: "View Contest",
      color: "#D4F7ED",
    },
    {
      label: "DSML Module Test: DAV - Probability and Stats",
      time: "18 Oct, 6:00 PM - 27 Oct, 11:00 PM",
      button: "View Contest",
      color: "#E2DBFA",
    },
  ];

  return (
    <Grid2 sx={styles}>
      <Box display={"flex"} alignItems={"start"}>
        <img src={ContestUpcoming} alt="Contest Upcoming" />
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap="16px"
          alignItems={"start"}
          ml={"16px"}
        >
          <Chip label="Upcoming" variant="filled" />
          <Typography variant="title" fontWeight={500}>
            DSML Module Test: Data Analytics and Visualisation - Fundamentals
          </Typography>
          <Typography display={"flex"} color="secondary.light">
            This contest along with your Mock Interview is mandatory for
            <Typography>job application eligibility</Typography>
          </Typography>
          <Box
            display={"flex"}
            alignItems={"center"}
            sx={(theme) => ({
              background: theme.palette.warning.main,
              padding: "8px",
              borderRadius: "8px",
            })}
          >
            <PrimaryIcon
              height="18px"
              width="18px"
              icon={CalendarUpcoming}
              fill={false}
            />
            &nbsp;
            <Link href="#" variant="body1" color="secondary">
              1st Attempt
            </Link>
            &nbsp;
            <Typography color="secondary.light"> is live from:</Typography>
            &nbsp;
            <Typography>
              Fri.15 Nov , 6:0 pm - Sun, 24Nov, 11:00 PM |
            </Typography>
            &nbsp;
            <PrimaryIcon height="18px" width="18px" icon={TimeUpcoming} />
            &nbsp;
            <Typography color="secondary.light">Duration:</Typography>
            &nbsp;
            <Typography>90 Mins</Typography>
          </Box>
          <Button
            variant="contained"
            sx={(theme) => ({
              background: "#F5F5F5",
              color: theme.palette.secondary.light,
            })}
          >
            Attempt Test
          </Button>
        </Box>
        <Box
          sx={(theme) => ({
            borderRadius: "8px",
            border: `1px solid ${theme.palette.border.blue}`,
            background: theme.palette.background.default,
            padding: "10px",
            marginLeft: "auto",
            "& p": {
              display: "flex",
              alignItems: "center",
              "& svg": {
                marginRight: "5px",
              },
              "& span": {
                fontWeight: 500,
                color: theme.palette.secondary.main,
              },
            },
          })}
        >
          <Typography color="secondary.light">
            <PrimaryIcon icon={CompletedIcon} color="success" />
            Score: <span> 70/100 </span> &nbsp; to pass
          </Typography>
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          background: theme.palette.background.default,
          borderRadius: "8px",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        })}
      >
        <Box>
          <Typography variant="title" fontWeight={500}>
            Your Attempts
          </Typography>
          <Typography color="secondary.light">
            You have 2 Attempts to clear the Test
          </Typography>
        </Box>
        <Grid2 spacing={2} container>
          {[...Array(2)]?.map((item, i) => {
            return (
              <Grid2 className="attemptBox" size={3} key={i}>
                <Chip size="small" variant="filled" label="Upcoming" />
                <Typography variant="subtitle" fontWeight={500}>
                  Attempt 1
                </Typography>
                <Typography color="secondary.light">
                  Fri, 15 Nov, 6:00 PM - Sun, 24 Nov, 11:00 PM
                </Typography>
                <Box
                  sx={(theme) => ({
                    background: theme.palette.primary.main,
                    borderRadius: "8px",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "-webkit-fill-available",
                  })}
                >
                  <Typography color="white" variant="subtitle" fontWeight={500}>
                    Score
                  </Typography>
                  <Typography color="white" variant="subtitle" fontWeight={500}>
                    N/A
                  </Typography>
                </Box>
              </Grid2>
            );
          })}
        </Grid2>
      </Box>
      <Typography variant="title" fontWeight={500}>
        Why this module test is important for you?
      </Typography>
      <Grid2 container spacing={2}>
        {impPoint?.map((item, i) => {
          return (
            <Grid2 className="impBox" size={4} key={`imp_${i}`}>
              <PrimaryIcon className="iconBox" icon={item?.icon} />
              {item?.content}
            </Grid2>
          );
        })}
      </Grid2>
      <ContestInstructions />
      <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
        <Typography variant="title" fontWeight={500}>
          Similar Contests
        </Typography>
        <Grid2 container spacing={2}>
          {similarContests?.map((item, i) => {
            return (
              <Grid2
                sx={(theme) => ({
                  background: item?.color,
                  padding: "16px",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  gap: "8px",
                })}
                key={`contest_${i}`}
                size={4}
              >
                <Typography variant="subtitle" fontWeight={500}>
                  {item?.label}
                </Typography>
                <Typography
                  color="secondary.light"
                  display={"flex"}
                  alignItems={"center"}
                  gap="8px"
                  mb="8px"
                >
                  <PrimaryIcon
                    icon={ClockIcon}
                    color="secondary"
                    variant="light"
                    width="16px"
                    height="16px"
                  />
                  {item?.time}
                </Typography>
                <Button variant="outlined" color="secondary">
                  {item?.button}
                </Button>
              </Grid2>
            );
          })}
        </Grid2>
      </Box>
    </Grid2>
  );
};

export default ContestTab;
